// extracted by mini-css-extract-plugin
export default {"btn":"button_btn__rc08F","btn__primary":"button_btn__primary__R7qxv","btn__secondary":"button_btn__secondary__OqsIZ"};